export default __webpack_public_path__ + "static/media/1858.7309ed8d.png";